import Panel from '@admin/components/panel'
import AppToken from '@admin/tokens/app'

const mapPropsToPanel = (props, context) => ({
  title: 't(Apps)',
  collection: {
    endpoint: `/api/admin/platform/teams/${props.team.id}/apps`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(App)', key: 'code', primary: true, format: AppToken }
    ],
    defaultSort: { key: 'code', order: 'asc' },
    entity: 'app',
    onClick: (record) => context.router.push(`/team/apps${record.path}/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
